export default "__VITE_ASSET__49fb4244__"